import React, { useEffect, useState } from "react";
import "./approvedposterlist.css";

const POSTER_DATA_URL = "https://conference.smdc.edu.pk/posterData.json";

const normalizePosterData = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .filter((item) => item && (item.name || item.title))
    .map((item) => ({
      name: item.name?.trim() || "Presenter to be announced",
      title: item.title?.trim() || "Title to be announced",
    }));
};

const AppPosterList = () => {
  const [posters, setPosters] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadPosters = async () => {
      try {
        const response = await fetch(`${POSTER_DATA_URL}?t=${Date.now()}`, {
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        if (isMounted) {
          setPosters(normalizePosterData(data));
        }
      } catch (error) {
        console.error("Error loading poster data:", error);
      }
    };

    loadPosters();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="approved-poster-container">
      <div className="approved-poster-content approved-poster-shell">
        <div className="approved-poster-header">
          <p className="approved-poster-kicker">Research Showcase</p>
          <h1>Approved Poster List</h1>
          <p className="approved-poster-content-text">
            For further information, please contact at {" "}
            <a href="mailto:maryam.fatima@sihs.org.pk">
              maryam.fatima@sihs.org.pk
            </a>
          </p>
        </div>

        <div className="approved-poster-grid">
          {posters.map((poster, index) => (
            <article className="approved-poster-card" key={`${poster.name}-${index}`}>
              <div className="approved-poster-name-chip">{poster.name}</div>
              <div className="approved-poster-title-panel">
                <p>{poster.title}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppPosterList;
